"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./RadioButton.css");
var RadioButton = /** @class */ (function (_super) {
    __extends(RadioButton, _super);
    function RadioButton(props) {
        var _this = _super.call(this, props) || this;
        _this.inputId = _this.guid();
        _this.containerId = _this.guid();
        _this.handleClick = _this.handleClick.bind(_this);
        _this.setInputRef = _this.setInputRef.bind(_this);
        _this.fetchCustomInputClassNames = _this.fetchCustomInputClassNames.bind(_this);
        _this.fetchCustomContainerDivClassNames = _this.fetchCustomContainerDivClassNames.bind(_this);
        _this.fetchCustomLabelClassNames = _this.fetchCustomLabelClassNames.bind(_this);
        return _this;
    }
    RadioButton.prototype.handleClick = function (e) {
        var elem = e.target;
        if (e.screenX === 0 && e.screenY === 0) {
            elem.setAttribute('event-type', 'keyboard');
        }
        else {
            elem.setAttribute('event-type', 'mouse');
        }
    };
    RadioButton.prototype.setInputRef = function (element) {
        this.inputRef = element;
    };
    RadioButton.prototype.render = function () {
        return (React.createElement("div", { className: [this.fetchCustomInputOuterDivClassNames(this.props)].join(' ') },
            React.createElement("label", { id: this.containerId, htmlFor: this.inputId, "data-test-id": this.props.testId, className: styles.radioContainer },
                React.createElement("input", __assign({ id: this.inputId, "aria-labelledby": this.containerId, className: [styles.radioInput, this.fetchCustomInputClassNames(this.props)].join(' '), type: "radio", name: this.props.name, checked: this.props.selected, onClick: this.handleClick, onChange: this.props.events.onChange, "event-type": "keyboard", ref: this.setInputRef }, this.props.data)),
                React.createElement("span", { className: styles.radioSpan }),
                React.createElement("div", { className: [styles.textContainer, this.fetchCustomContainerDivClassNames(this.props)].join(' ') },
                    React.createElement("span", { className: [styles.radioLabel, this.fetchCustomLabelClassNames(this.props)].join(' ') }, this.props.options.customLabel ? this.renderChildrenIn() :
                        (this.props.data.customValue ? this.props.data.customValue : this.props.data.value)),
                    this.props.options.customLabel ? null : this.renderChildrenIn())),
            React.createElement("div", null, this.renderChildrenOut())));
    };
    RadioButton.prototype.fetchCustomInputClassNames = function (props) {
        if (props.options && props.options.className && props.options.className.input) {
            return props.options.className.input;
        }
        else {
            return '';
        }
    };
    RadioButton.prototype.fetchCustomInputOuterDivClassNames = function (props) {
        if (props.options && props.options.className && props.options.className.outerDiv) {
            return props.options.className.outerDiv;
        }
        else {
            return '';
        }
    };
    RadioButton.prototype.fetchCustomContainerDivClassNames = function (props) {
        if (props.options && props.options.className && props.options.className.containerDiv) {
            return props.options.className.containerDiv;
        }
        else {
            return '';
        }
    };
    RadioButton.prototype.fetchCustomLabelClassNames = function (props) {
        if (props.options && props.options.className && props.options.className.label) {
            return props.options.className.label;
        }
        else {
            return '';
        }
    };
    RadioButton.prototype.renderChildrenIn = function () {
        if (this.props.children && !this.props.data.contentChildOut) {
            if (this.props.accordion) {
                return (React.createElement("div", { className: this.props.selected ? styles.accordionExpand : styles.accordionCollapse }, this.props.children));
            }
            else {
                return React.createElement("div", null, this.props.children);
            }
        }
        return null;
    };
    RadioButton.prototype.renderChildrenOut = function () {
        if (this.props.children && this.props.data.contentChildOut) {
            return React.createElement("div", null, this.props.children);
        }
        return null;
    };
    RadioButton.prototype.guid = function () {
        return "" + this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4();
    };
    RadioButton.prototype.S4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    RadioButton.defaultProps = {
        options: {
            className: {
                input: '',
                label: '',
            },
        },
    };
    return RadioButton;
}(React.Component));
exports.default = RadioButton;
//# sourceMappingURL=RadioButton.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/RadioGroup/components/RadioButton/RadioButton.js
// module id = 1227
// module chunks = 8